<app-modal [title]="pageTitle" [ngClass]="{ 'partner-hide-footer': !isAdmin }">
  <div ngbAutoFocus class="modal-content pt-0" style="overflow: visible">
    <div *ngIf="viewStatus == 1">
      <app-shimmer-view [viewType]="'form'"></app-shimmer-view>
    </div>

    <div *ngIf="viewStatus == 0">
      <ng-container *ngIf="contactRequest">

        <div class="list">
          <div class="item first-item" *ngIf="partnerContactRequest">
            <div class="line w-100">
              <span class="title">
                <i class="ti ti-clock"></i>
                {{ "Received at" | translate }}
              </span>
              <span class="desc">
                {{ partnerContactRequest.assignedAt | date:'dd/MM/yyyy HH:mm':'':'en-US' }}
              </span>
            </div>
          </div>

          <div class="item"
            *ngIf="partnerContactRequest && partnerContactRequest.expiresAt && partnerContactRequest.status !== 'PURCHASED'">
            <div class="line w-100">
              <span class="title">
                <i class="ti ti-hourglass"></i>
                {{ "Expires in" | translate }}
              </span>
              <span class="desc">
                <app-countdown-badge-table [request]="partnerContactRequest" [textOnly]="true"></app-countdown-badge-table>
              </span>
            </div>
          </div>

          <div class="item" [class.first-item]="!partnerContactRequest">
            <div class="line w-100">
              <span class="title">
                <i class="ti ti-user"></i>
                {{ "Name" | translate }}
              </span>
              <span class="desc">{{ contactRequest.lead | leadName }}</span>
            </div>
          </div>

          <div class="item" *ngIf="isAdmin && contactRequest">
            <div class="line">
              <span class="title"><i class="ti ti-tag"></i> {{ "Status" | translate }}</span>
              <span class="desc">
                <app-status-badge page="contact" [status]="contactRequest.status"
                  [availableStatuses]="statusBadgeOptions">
                </app-status-badge>
              </span>
            </div>
          </div>

          <div class="item" *ngIf="contactRequest.motivation">
            <div class="line w-100">
              <span class="title">
                <i class="ti ti-brain"></i>
                Motivation
              </span>
              <span class="desc">{{ contactRequest.motivation.toLowerCase().charAt(0).toUpperCase() +
                contactRequest.motivation.toLowerCase().slice(1) }}</span>
            </div>
          </div>

          <div class="item" *ngIf="formattedCountry">
            <div class="line w-100">
              <span class="title">
                <i class="ti ti-map-pin"></i>
                {{ "Country" | translate }}
              </span>
              <span class="desc">{{ formattedCountry }}</span>
            </div>
          </div>

          <div class="item" *ngIf="contactRequest.lead.phoneNumber">
            <div class="line w-100">
              <span class="title">
                <i class="ti ti-phone"></i>
                {{ "Phone number" | translate }}
              </span>
              <span class="desc">
                {{ contactRequest.lead.phoneNumber }}
              </span>
            </div>
          </div>

          <div class="item"
            *ngIf="!contactRequest.lead.phoneNumber && contactRequest.lead.contactInfoRestricted && partnerContactRequest?.status === 'PURCHASED'">
            <div class="line w-100">
              <span class="title">
                <i class="ti ti-phone"></i>
                {{ "Phone number" | translate }}
              </span>
              <span class="desc text-muted">{{ hiddenContactLabel }}</span>
            </div>
          </div>

          <div class="item"
            *ngIf="!contactRequest.lead.phoneNumber && !isAdmin && partnerContactRequest && partnerContactRequest.status != 'PURCHASED' && profileService.meets('MANAGE_REQUESTS')">
            <div class="line w-100">
              <span class="title">
                <i class="ti ti-phone"></i>
                {{ "Phone number" | translate }}
              </span>
              <div>
                <app-button [buttonType]="'success'" [size]="'sm'" [label]="'Unlock phone number' | translate"
                  (onClick)="showPhoneNumberConfirmation()" [icon]="'lock-open'" [cssClass]="'btn-narrow'"
                  [isDisabled]="isWalletDebtExceeded">
                </app-button>
              </div>
            </div>
          </div>

          <div class="item" *ngIf="!isAdmin && partnerContactRequest && partnerContactRequest.status == 'PURCHASED'">
            <div class="line w-100">
              <span class="title">
                <i class="ti ti-tag"></i>
                {{ "Status" | translate }}
              </span>
              <div>
                <app-label-dropdown-content *ngIf="viewStatus === ViewStatus.READY"
                  [label]="partnerContactRequest.label" [data]="partnerContactRequest"
                  (labelChanged)="updateLabel($event)">
                </app-label-dropdown-content>
              </div>
            </div>
            <div class="line w-100" *ngIf="partnerContactRequest?.purchasedByName">
              <span class="title"><i class="ti ti-lock-open"></i> Unlocked by</span>
              <span class="desc">{{ partnerContactRequest?.purchasedByName }}</span>
            </div>
          </div>

          <app-retention-disclaimer
            *ngIf="!isAdmin && partnerContactRequest && partnerContactRequest.status == 'PURCHASED'">
          </app-retention-disclaimer>
        </div>

      </ng-container>
    </div>
  </div>


</app-modal>

<app-confirmation-modal #confirmationModal (confirmed)="onPhoneNumberConfirmed($event)"
  (dismissed)="onPhoneNumberDismissed()">
</app-confirmation-modal>